import { t } from '@lingui/core/macro';
import { TireQuoteRecordCustomer, TireQuoteRecordList } from '@navio/nsdk';
import { cn } from 'noddi-ui-common';
import { NoddiBadge } from 'noddi-ui-web';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'noddi-ui-web/src/base';

import { PickerMode } from '../../../../stores/tireOfferPickerStore';
import { TabKey } from '../utils/tabKeys';
import { AcceptedTab } from './AcceptedTab';
import { ModeToggle } from './ModeBanner';
import { PendingTab } from './PendingTab';

type Props = {
  activeTab: TabKey;
  onTabChange: (value: TabKey) => void;
  mode: PickerMode;
  onModeChange: (mode: PickerMode) => void;
  pendingOffers: TireQuoteRecordCustomer[];
  pendingCount: number;
  acceptedOffers: TireQuoteRecordList[];
};

export const TireOfferTabsSection = ({
  activeTab,
  onTabChange,
  mode,
  onModeChange,
  pendingOffers,
  pendingCount,
  acceptedOffers
}: Props) => (
  <Tabs value={activeTab} onValueChange={(value) => onTabChange(value as TabKey)} defaultValue='pending'>
    <div className='flex flex-col gap-3 md:flex-row md:items-center md:justify-between'>
      <TabsList>
        <TabTriggerLabel value='pending' label={t`Pending`} count={pendingCount} active={activeTab === 'pending'} />
        <TabTriggerLabel
          value='accepted'
          label={t`Accepted`}
          count={acceptedOffers.length}
          active={activeTab === 'accepted'}
        />
      </TabsList>

      {activeTab === 'pending' && <ModeToggle mode={mode} onChange={onModeChange} />}
    </div>

    <TabsContent value='pending'>
      <PendingTab offers={pendingOffers} />
    </TabsContent>
    <TabsContent value='accepted'>
      <AcceptedTab offers={acceptedOffers} />
    </TabsContent>
  </Tabs>
);

type TabTriggerLabelProps = {
  value: TabKey;
  label: string;
  count: number;
  active: boolean;
};

const TabTriggerLabel = ({ value, label, count, active }: TabTriggerLabelProps) => (
  <TabsTrigger value={value}>
    <div className='flex items-center gap-1.5'>
      <span>{label}</span>
      <NoddiBadge
        variant='outline'
        className={cn('ml-1 border-none px-2 py-0 text-[10px]', active ? 'bg-gray-200 text-gray-800' : 'bg-white/90')}
      >
        {count}
      </NoddiBadge>
    </div>
  </TabsTrigger>
);
